import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Button, Box, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const navItems = [
  { label: 'About Us', path: '/about' },
  { label: 'What We Do', path: '/services' },
  { label: 'Export', path: '/countries' },
  { label: 'Contact', path: '/contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/');
  };

  const handleDrawerToggle = () => {
    setDrawerOpen((prev) => !prev);
  };

  return (
    <AppBar
      position="fixed"
      elevation={scrolled ? 2 : 0}
      sx={{
        bgcolor: 'background.paper',
        color: 'text.primary',
        transition: 'all 0.2s',
        py: scrolled ? 0.5 : 1.5,
        boxShadow: scrolled ? '0 1px 8px 0 rgba(0,0,0,0.04)' : 'none',
        borderBottom: scrolled ? '1px solid #ececec' : '1px solid transparent',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1201,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: undefined, px: { xs: 1, sm: 3, md: 6 } }}>
        {/* Only PNG logo on the left */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            component="img"
            src="/digiwood_logo-removebg-preview.png"
            alt="Digiwood Logo"
            sx={{ height: 60, cursor: 'pointer' }}
            onClick={handleLogoClick}
          />
        </Box>
        {/* Desktop Nav */}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 0.5 }}>
          {navItems.map((item) => (
            <Button
              key={item.path}
              color="inherit"
              component={RouterLink}
              to={item.path}
              sx={{
                ml: 2,
                fontWeight: 700,
                fontSize: '1.08rem',
                letterSpacing: '0.04em',
                px: 1.8,
                py: 0.7,
                borderRadius: 2.5,
                minWidth: 0,
                transition: 'all 0.18s',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: 'primary.main',
                  color: 'background.paper',
                  boxShadow: '0 2px 8px 0 rgba(123,94,59,0.10)',
                  fontWeight: 900,
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
        {/* Mobile Nav: Hamburger */}
        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
          <IconButton
            color="inherit"
            edge="end"
            onClick={handleDrawerToggle}
            aria-label="menu"
            sx={{ ml: 1 }}
          >
            <MenuIcon sx={{ fontSize: 32 }} />
          </IconButton>
        </Box>
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={handleDrawerToggle}
          PaperProps={{
            sx: {
              width: 240,
              bgcolor: 'background.paper',
              top: { xs: '64px', sm: '72px', md: 0 },
              height: { xs: 'calc(100% - 64px)', sm: 'calc(100% - 72px)', md: '100%' },
            },
          }}
        >
          <Box sx={{ width: 240, pt: 3 }} role="presentation" onClick={handleDrawerToggle}>
            <List>
              {navItems.map((item) => (
                <ListItem key={item.path} disablePadding>
                  <ListItemButton component={RouterLink} to={item.path} sx={{ px: 3 }}>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        fontWeight: 700,
                        fontSize: '1.13rem',
                        color: 'primary.main',
                        letterSpacing: '0.04em',
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 